import apiClient from '../apiClient';

export const getNewsletterStats = async () => {
  const response = await apiClient.get('/admin/newsletter/stats');
  return response.data;
};

export const getNewsletterSubscribers = async ({ search = '', skip = 0, limit = 50 } = {}) => {
  const response = await apiClient.get('/admin/newsletter', {
    params: { search: search || undefined, skip, limit },
  });
  return response.data;
};

export const deleteNewsletterSubscriber = async (subscriberId) => {
  await apiClient.delete(`/admin/newsletter/${subscriberId}`);
};
